define [
    "jquery", "lodash", "backbone", "scriptjs",
    "bootstrap", "angular", "angular-resource", "angular-sanitize",
    "angular-ui-router", "angular-ui-router.statehelper", "angular-ui-bootstrap",
    "angular-moment", "ngstorage", "angular-input-masks/us", "ng-file-upload",
    "angular-ui-mask", "angular-hotkeys", "./assets/css/main.css", "angular-cookies",
    "angulartics", "angulartics-google-tag-manager", "angular-flash-alert",
    "angular-smart-table", "ng-tags-input", "angular-clipboard", "angular-paging",
    './app.css', './homesmart.scss', "payform", "validator", "js-cookie", "logrocket",
], ($, _, Backbone) ->
  Raven = require('raven-js')

  Cookies = require('js-cookie')

  LogRocket = require('logrocket')

  if ENV.LOGROCKET_ID
    try
      LogRocket.init(ENV.LOGROCKET_ID)
    catch error

  ravenOptions = {
    ignoreErrors: [
      # Random plugins/extensions
      'top.GLOBALS',
      # See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      # Facebook borked
      'fb_xd_fragment',
      #ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
      #See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      # See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      # Generic error code from errors outside the security sandbox
      # You can delete this if using raven.js > 1.0, which ignores these automatically.
      'Script error.',
      "undefined is not an object (evaluating 'a[e].resolve')"
    ],
    ignoreUrls: [
      # Facebook flakiness
      /graph\.facebook\.com/i,
      # Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      # Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      # Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      # Safari extensions
      /safari-extension\//i,
      # Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, # Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ]
  }
  
  Raven		
    .config(ENV.SENTRY_DSN, ravenOptions)		
    .addPlugin(require('raven-js/plugins/angular'), angular)		
    .install()
  

  angular.module 'rentapplicationApp', [
    'ngRaven', 'ngStorage', 'ngResource', 'ngSanitize', 'ngFileUpload',
    'ui.router', 'ui.router.stateHelper', 'ui.bootstrap', "ui.utils.masks", 'angularMoment', 'ui.mask',
    'cfp.hotkeys', "ngCookies", "ngFlash", "angulartics", "angulartics.google.tagmanager",
    "smart-table", "ngTagsInput", "angular-clipboard", "bw.paging",
  ]
  .constant "RENTAPPLICATION_API_URL", ENV.RENTAPPLICATION_API_URL
  .constant "WHITE_LABEL", ENV.WHITE_LABEL
  .constant "COMPANY_NAME", ENV.COMPANY_NAME
  .constant "SUPPORT_EMAIL", ENV.SUPPORT_EMAIL
  .constant "THEME_COLOR", ENV.THEME_COLOR
  .constant "SUBNAV_THEME_COLOR", ENV.SUBNAV_THEME_COLOR
  .constant "COMPANY_LOGO_URL", ENV.COMPANY_LOGO_URL
  .constant "COMPANY_LOGO_LARGE_URL", ENV.COMPANY_LOGO_LARGE_URL
  .constant "COMPANY_LOGO_ONLY", ENV.COMPANY_LOGO_ONLY
  .constant "GROOVE_WIDGET", ENV.GROOVE_WIDGET
  .constant "GROOVE_WIDGET_PROSPECT", ENV.GROOVE_WIDGET_PROSPECT
  .constant "GROOVE_WIDGET_LANDLORD", ENV.GROOVE_WIDGET_LANDLORD
  .constant "GROOVE_WIDGET_APPLICANT", ENV.GROOVE_WIDGET_APPLICANT
  .constant "TAPFILIATE_ENABLED", ENV.TAPFILIATE_ENABLED
  .constant "RSP_ALERT_ENABLED", ENV.RSP_ALERT_ENABLED
  .constant "WELCOME_MODAL_ENABLED", ENV.WELCOME_MODAL_ENABLED
  .constant "BETA_FRONTEND_BASE_URL", ENV.BETA_FRONTEND_BASE_URL
  .constant "LOGROCKET_ID", ENV.LOGROCKET_ID
  .constant "HOST", window.location.origin
  .constant "HOSTNAME", window.location.hostname
  .constant "MIN_DESKTOP_WIDTH", 768
  .constant "INFO_PAGE_SLUGS", require("../lib/freeforms/info_page_slugs.coffee")
  .service 'RentappService', require("./services/RentappService")
  .service 'Experian', require("./services/experian/experian")
  .factory "User", require("./resources/User.coffee")
  .factory "Landlord", require("./resources/Landlord.coffee")
  .factory "ApplicationTemplate", require("./resources/ApplicationTemplate.coffee")
  .factory "ApplicationBundle", require("./resources/ApplicationBundle.coffee")
  .factory "Application", require("./resources/Application.coffee")
  .factory "ReportSourceProfile", require("./resources/ReportSourceProfile.coffee")
  .factory "Account", require("./resources/Account.coffee")
  .factory "Applicant", require("./resources/Applicant.coffee")
  .directive "navbar", require("./directives/navbar/navbar.coffee")
  .directive "subnavbar", require('./directives/subnavbar/subnavbar.coffee')
  .directive "sidebar", require("./directives/sidebar/sidebar.coffee")
  .directive "raFooter", require("./directives/footer/footer.coffee")

  .directive "integrations", require("./directives/integrations/integrations.coffee")
  .directive "builder", require("./directives/freeforms/builder/builder.coffee")
  .directive "singleline", require("./directives/freeforms/single_line/single_line.coffee")
  .directive "multiline", require("./directives/freeforms/multi_line/multi_line.coffee")
  .directive "newSignature", require("./directives/freeforms/newSignature/signature.coffee")
  .directive "newSignatureModal", require("./directives/freeforms/newSignatureModal/signatureBase.coffee")
  .directive "signature", require("./directives/freeforms/signature/signature.coffee")
  .directive "signatureText", require("./directives/freeforms/signatureText/signatureText.coffee")
  .directive "signatureModal", require("./directives/freeforms/signatureModal/signatureModal.coffee")
  .directive "coapplicants", require("./directives/freeforms/coapplicants/coapplicants.coffee")
  .directive "agent", require("./directives/freeforms/agents/agents.coffee")
  .directive "ssn", require("./directives/freeforms/ssn/ssn.coffee")
  .directive "email", require("./directives/freeforms/email/email.coffee")
  .directive "choice", require("./directives/freeforms/choice/choice.coffee")
  .directive "phone", require("./directives/freeforms/phone/phone.coffee")
  .directive "datesplit", require("./directives/freeforms/datesplit/datesplit.coffee")
  .directive "file", require("./directives/freeforms/file/file.coffee")
  .directive "state", require("./directives/freeforms/state/state.coffee")
  .directive "textdisplay", require("./directives/freeforms/text_display/text_display.coffee")
  .directive "checkbox", require("./directives/freeforms/checkbox/checkbox.coffee")
  .directive "dropdown", require("./directives/freeforms/dropdown/dropdown.coffee")
  .directive "currency", require("./directives/freeforms/currency/currency.coffee")
  .directive "unit", require("./directives/freeforms/unit/unit.coffee")
  .directive "freeformsWidget", require("./directives/freeforms/freeformsWidget.coffee")
  .directive "freeformsWarning", require("./directives/freeforms/warning/warning.coffee")

  .directive "notificationsTable", require("./directives/notificationsTable/notificationsTable.coffee")
  .directive "passwordChangeForm", require("./directives/passwordChangeForm/passwordChangeForm.coffee")
  .directive "appbundlesTable", require("./directives/appbundlesTable/appbundlesTable.coffee")
  .directive "applicantAppbundlesTable", require("./directives/applicantAppbundlesTable/applicantAppbundlesTable.coffee")
  .directive "apptemplatesTable", require("./directives/apptemplatesTable/apptemplatesTable.coffee")
  .directive "quickformsTable", require("./directives/quickformsTable/quickformsTable.coffee")
  .directive "mypaymentsTable", require("./directives/mypaymentsTable/mypaymentsTable.coffee")
  .directive "application", require("./directives/application/application.coffee")
  .directive "iframeSrcdoc", require("./directives/iframeSrcdoc/iframeSrcdoc.coffee")
  .directive "rspSignupPrompts", require("./directives/rspSignupPrompts/rspSignupPrompts.coffee")
  .directive "experianSignupPrompt", require("./directives/rspSignupPrompts/report_source_profiles/experian/experian.coffee")
  .directive "smartmoveSignupPrompt", require("./directives/rspSignupPrompts/report_source_profiles/smartmove/smartmove.coffee")
  .directive "appCard", require("./directives/appCard/appCard.coffee")
  .directive "acceptApplication", require("./directives/acceptRejectApplication/acceptApplication/acceptApplication.coffee")
  .directive "rejectApplication", require("./directives/acceptRejectApplication/rejectApplication/rejectApplication.coffee")
  .directive "uploadCompanyLogo", require("./directives/uploadCompanyLogo/uploadCompanyLogo.coffee")
  .directive "passwordGuide", require("./directives/passwordGuide/passwordGuide.coffee")
  .directive "supportMessage", require("./directives/supportMessage/supportMessage.coffee")
  .directive "usernameAvailable", require("./directives/usernameAvailable/usernameAvailable.coffee")
  .directive "applicationShareModal", require("./directives/applicationShareModal/applicationShareModal.coffee")
  .directive "groove", require("./directives/groove/groove.coffee")
  .directive "tapfiliate", require("./directives/tapfiliate/tapfiliate.coffee")
  .directive "sendApplicationLink", require("./directives/sendApplicationLink/sendApplicationLink.coffee")
  .directive "appActionBar", require("./directives/appActionBar/appActionBar.coffee")
  .directive "raPagination", require("./directives/pagination/pagination.coffee")
  .directive "overflow", require("./directives/overflow/overflow.coffee")
  .filter 'concat', require('./filters/concat.coffee')
  .filter 'to_trusted', ($sce) -> ((text) -> $sce.trustAsHtml(text))
  .filter 'base64', ->
    (input) ->
      utf8_to_b64 = (str) ->
        btoa unescape(encodeURIComponent(str))
      if input
        return utf8_to_b64(input)
      return
  .filter 'humanize_date', ->
    (date) ->
      return moment(date).fromNow()
  .config ($urlMatcherFactoryProvider) ->
    $urlMatcherFactoryProvider.strictMode false
    $urlMatcherFactoryProvider.caseInsensitive true
  .config require("./components/routes.coffee")
  .config ($urlRouterProvider, $locationProvider, $httpProvider, $resourceProvider, $localStorageProvider, FlashProvider) ->
    $httpProvider.interceptors.push () ->
      'request': (config) ->
        config.withCredentials = true
        if Cookies.get('csrftoken')
          $httpProvider.defaults.headers.common['X-CSRFToken'] = Cookies.get('csrftoken')
        config

    $urlRouterProvider.when '/users/payments/', '/dashboard/payments/'
    $urlRouterProvider.when '/users/settings/landlord/', '/dashboard/settings/'
    $urlRouterProvider.when '/app/:appId/payment/', '/applications/pay/:appId/'
    $urlRouterProvider.when '/app/:appId/view/', '/dashboard/view/:appId/'
    $urlRouterProvider.when '/app/:appId/view/:shareToken/', '/dashboard/view/:appId/:shareToken'
    $urlRouterProvider.when '/accounts/login/', '/login/'

    $urlRouterProvider.rule ($injector, $location) ->
        path = $location.url()
        if path[path.length - 1] is '/' or path.indexOf('/?') > -1
            return path
        else if path.indexOf('?') > -1
            return path.replace '?', '/?'
        else
          return path + '/'
    $urlRouterProvider.otherwise ($injector, $location) -> $injector.get("$state").go "root.home.404"

    $resourceProvider.defaults.stripTrailingSlashes = false;
    $locationProvider.html5Mode(true).hashPrefix('!')
    FlashProvider.setTimeout(3000)
    FlashProvider.setShowClose(true)

  .run ($window, $urlRouter, $rootScope, $cacheFactory, $uibModal, $localStorage,
    RentappService, HOSTNAME, $state, RENTAPPLICATION_API_URL, HOST, WHITE_LABEL,
    THEME_COLOR, SUBNAV_THEME_COLOR, COMPANY_NAME, SUPPORT_EMAIL, COMPANY_LOGO_URL, 
    COMPANY_LOGO_LARGE_URL, COMPANY_LOGO_ONLY, $location, $cookies, GROOVE_WIDGET, 
    TAPFILIATE_ENABLED, RSP_ALERT_ENABLED, WELCOME_MODAL_ENABLED, Flash, BETA_FRONTEND_BASE_URL, LOGROCKET_ID) ->
    angular.element($window).bind 'resize', ->
      if $($window).width() < 768
        $localStorage.sidebar_collapsed = true

    $rootScope.RENTAPPLICATION_API_URL = RENTAPPLICATION_API_URL
    # HOST -> with port and scheme e.g. https://www.rentapplication.net:8000
    # HOSTNAME -> without url and scheme e.g. www.rentapplication.net
    $rootScope.HOST = HOST
    $rootScope.HOSTNAME = HOSTNAME
    emailHost = HOSTNAME.replace("www.", "")
    $rootScope.HOSTNAME_NOWWW = emailHost

    $rootScope.VERIFICATION_EMAIL = SUPPORT_EMAIL
    $rootScope.SUPPORT_EMAIL = SUPPORT_EMAIL
    $rootScope.PRIVACY_EMAIL = SUPPORT_EMAIL
    $rootScope.WHITE_LABEL = WHITE_LABEL
    $rootScope.COMPANY_NAME = COMPANY_NAME
    $rootScope.GROOVE_WIDGET = GROOVE_WIDGET
    $rootScope.TAPFILIATE_ENABLED = TAPFILIATE_ENABLED
    $rootScope.RSP_ALERT_ENABLED = RSP_ALERT_ENABLED
    $rootScope.WELCOME_MODAL_ENABLED = WELCOME_MODAL_ENABLED
    $rootScope.LOGROCKET_ID = LOGROCKET_ID

    if THEME_COLOR != "default"
      $rootScope.THEME_COLOR = THEME_COLOR
    else
      $rootScope.THEME_COLOR = "#3659c0"

    if SUBNAV_THEME_COLOR != "default"
      $rootScope.SUBNAV_THEME_COLOR = SUBNAV_THEME_COLOR
    else
      $rootScope.SUBNAV_THEME_COLOR = "#3659c0"

    $rootScope.COMPANY_LOGO_ONLY = COMPANY_LOGO_ONLY
    $rootScope.COMPANY_LOGO_URL = COMPANY_LOGO_URL
    $rootScope.COMPANY_LOGO_LARGE_URL = COMPANY_LOGO_LARGE_URL

    # During unit testing, suppress http requests initial module load
    unless ENV.ON_TEST
      RentappService.getMe()
        .then (user) ->
          if LOGROCKET_ID
            LogRocket = require('logrocket')
            LogRocket.identify(user.username, user)

    $.ajaxSetup
      beforeSend: (jqXHR, settings) ->
        settings.withCredentials = true
    
    # For external links (marketing pages)
    # load pages directly
    $rootScope.$on '$stateChangeStart', (event, toState, toParams, fromState, fromParams) ->
      if fromState.name and toState.external_link == true
        event.preventDefault()
        url = $state.href(toState.name, toParams);
        window.location.replace("#{HOST}#{url}")
   
    $rootScope.$on '$stateChangeError', (event, toState, toParams, fromState, fromParams, promise) ->
      event.preventDefault()
      if promise.status == 401
        return $state.go "root.home.403"
      else if promise.status == 404
        return $state.go "root.home.404"
      else if promise.status == 500
        return $state.go "root.home.500"
      else
        return $state.go "root.home.500"

    $rootScope.$on '$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) ->
      Flash.clear()
      isStatePublic = (state) ->
        if typeof state.public == "boolean"
          return state.public
        else if state.parent
          return isStatePublic(state.parent)

      if $state.current.name == "root"
        return $state.go "root.home.landing"
      else if $state.current.name == "root.home"
        return $state.go "root.home.landing"
      
      unauthenticated_view_app_check = not toParams.shareToken and not fromState.name and toState.name == 'root.dashboard.view_application'

      if not isStatePublic(toState) or unauthenticated_view_app_check
        event.preventDefault()
        RentappService.getMe()
        .then (user) ->
          if user.landlord && user.landlord.edge_enabled
            location.href = "#{BETA_FRONTEND_BASE_URL}/login"

          $urlRouter.sync()
        .catch (r) ->
          if r.status == 401
            if unauthenticated_view_app_check
              if WHITE_LABEL
                $state.go "root.home.landing", { view_app: toParams.application_id }
              else
                $state.go "root.home.login", { view_app: toParams.application_id }
            else
              $state.go "root.home.403"
            return
          else
            $state.go "root.home.landing"
            return

    $rootScope.$on '$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) ->
      $rootScope.title = "HomeSmart Rentals"
      $("html, body").animate({ scrollTop: 0 }, 100)
      if toState.name
        $rootScope.bodyClasses = toState.name.replace /\./g, " "
      # Executing VWO tracking code on state/URL change
      # See: https://vwo.com/knowledge/use-vwo-on-single-page-apps/ for more info
      #window.executeTrackingCode()

    $rootScope.$on '$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) ->
      unless $cookies.get('ORIGINAL_HTTP_REFERER')
        $cookies.put('ORIGINAL_HTTP_REFERER', document.referrer)
      unless $cookies.get('ORIGINAL_ENTRY_PAGE')
        $cookies.put('ORIGINAL_ENTRY_PAGE', $location.url())

    $rootScope.$storage = $localStorage

    proxiedSync = Backbone.sync
    Backbone.sync = (method, model, options) ->
      options or {}
      options.crossDomain = true
      options.xhrFields = options.xhrFields or {}
      options.xhrFields.withCredentials = true
      return proxiedSync(method, model, options)

## sourceMappingURL=app.js.map



// WEBPACK FOOTER //
// ./app.coffee